import { Injectable } from '@angular/core';

import { COUNTRY_CODES } from '@core/constants';
import { sortBy } from '@core/helpers';

export interface ICountryOption {
  key: string;
  value: string;
}

@Injectable({
  providedIn: 'root',
})
export class CountryOptionsService {
  /**
   * Gets the list of country options for select dropdowns from the country code constants.
   */
  public getOrderedOptions(): ICountryOption[] {
    let shortcutOptions: ICountryOption[] = Object.entries(COUNTRY_CODES.SHORTCUTS).map(([key, value]) => ({key, value}));
    shortcutOptions = sortBy(shortcutOptions, 'value');
    // Adds the delimiter after the shortcut options
    shortcutOptions.push({key: '', value: '-----------------------'});

    let allOptions: ICountryOption[] = Object.entries(COUNTRY_CODES.ALL).map(([key, value]) => ({key, value}));
    allOptions = sortBy(allOptions, 'value');
    return shortcutOptions.concat(allOptions);
  }
}
